import { t } from "@lingui/macro";
import { classNames } from "@winamp/ui/utils/classNames.js";

export const images = {
  "7 digital": "7_digital.png",
  adaptr: "adaptr.png",
  "amazon music": "amazon_music.png",
  "amazon prime": "amazon_prime.png",
  "amazon unlimited": "amazon_music.png",
  anghami: "anghami.png",
  "apple music": "apple_music.png",
  "itunes / apple music": "apple_music.png",
  "audible magic": "audible_magic.png",
  awa: "awa.png",
  beatport: "beatport.png",
  bmat: "bmat.png",
  boomplay: "boomplay.png",
  "claro música": "claro_musica.png",
  deezer: "deezer.png",
  "facebook rights manager": "facebook.png",
  gracenote: "gracenote.png",
  iheart: "i_heart.png",
  "imi mobile": "imi.png",
  "itunes store | apple music": "apple_music.png",
  jaxsta: "jaxsta.png",
  jiosaavn: "jiosaavn.png",
  joox: "joox.png",
  kanjian: "kanjian.png",
  "kdigital media": "kdigital_media.png",
  kkbox: "kkbox.png",
  lickd: "lickd.png",
  lyricfind: "lyric_find.png",
  mixcloud: "mixcloud.png",
  "rhapsody/napster": "napster.png",
  "netease cloud music": "netease_cloud_music.png",
  pandora: "pandora.png",
  peloton: "peloton.png",
  resso: "resso.png",
  shazam: "shazam.png",
  snapchat: "snapchat.png",
  soundcloud: "soundcloud.png",
  soundexchange: "soundexchange.png",
  spotify: "spotify.png",
  tencent: "tencent.png",
  tidal: "tidal.png",
  tiktok: "tiktok.png",
  traxsource: "traxsource.png",
  "tiktok music / resso": "tiktok.png",
  trebel: "trebel.png",
  twitch: "twitch.png",
  winamp: "winamp.png",
  yandex: "yandex.png",
  "winamp colorfull": "winamp_colorfull.png",
  "youtube art tracks": "youtube_music.png",
  "youtube music": "youtube_music.png",
};
export type DigitalServiceProvider = keyof typeof images;

interface IDigitalServiceProviderImg
  extends React.HTMLAttributes<HTMLImageElement> {
  type: string;
}

export function DigitalServiceProviderImg({
  type,
  ...props
}: IDigitalServiceProviderImg) {
  return (
    <img
      {...props}
      src={`/static/assets/digital-service-providers/${images[type.toLocaleLowerCase() as DigitalServiceProvider]}`}
      alt={t`Logo of ${type}`}
      className={classNames("h-20 w-20", props.className)}
    />
  );
}
